module.exports = __webpack_public_path__ + "static/media/DataProtection_en.81509259.md";